<template>
  <transition name="input-search">
    <div
      v-if="showSearch"
      class="inline-block w-full absolute text-center input-search-line nav-list"
    >
      <div
        class="h-full absolute input-s-mask cursor-pointer z-1"
        @click="closeSearch"
      ></div>
      <div class="h-full w-full fixed mask-css z-1" @click="closeSearch"></div>
      <div class="relative w-auto inline-block w-3/5 z-1">
        <input
          id="imitateInput"
          class="imitate-input text-left"
          type="text"
          v-model="keyWord"
          placeholder="搜索关键词..."
          autofocus="autofocus"
          @keyup.enter="windowOpen({ type: 'all' })"
        />
        <!-- @input="searchInput" -->
        <i
          class="iconfont icon-search imitate-input-icon cursor-pointer"
          @click="windowOpen({ type: 'all' })"
        ></i>
        <transition name="search-simple-result" key="input-search-simple">
          <div
            v-if="showSimpleResult"
            class="inline-block w-full absolute text-center input-search-simple"
          >
            <ul
              v-if="
                searchData && searchData.data && searchData.data.length !== 0
              "
            >
              <li class="clearfix ss-li-title cursor-default">
                <div class="float-left">
                  共搜索到
                  <span class="c-hover f-18">{{ searchData.total }}</span>
                  个结果：“{{ keyWord }}”
                </div>
                <div
                  class="float-right ss-li-right-btn cursor-pointer"
                  @click="windowOpen({ type: 'all' })"
                >
                  查看详情
                </div>
              </li>
              <li
                class="clearfix ss-li-content"
                v-for="data in searchData.data"
                :key="data.type"
              >
                <div class="float-left text-left relative w-full">
                  <div
                    class="absolute content-center text-center cursor-default min-w-56"
                  >
                    <div>{{ filterType(data.type) }}</div>
                    <div
                      class="content-left-bgc c-hover text-center cursor-pointer inline-block w-auto"
                      @click="windowOpen(data)"
                    >
                      {{ data.total }}
                    </div>
                  </div>
                  <ul class="w-full content-right">
                    <li
                      class="w-full clearfix"
                      v-for="item in data.data"
                      :key="item.id"
                      @click="listClickFn(item)"
                    >
                      <div class="float-left cursor-pointer">
                        {{ item.title }}
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div v-else class="text-center no-data">暂无数据</div>
          </div>
        </transition>
      </div>
      <SearchJumpInfo ref="SearchJumpInfo"></SearchJumpInfo>
    </div>
  </transition>
</template>
<script>
import link from '@/core/mixins/link'
import SearchJumpInfo from '@/components/search/SearchJumpInfo'
import { getSearchCount } from '@/core/api'

export function debounce(func, delay) {
  let timer
  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

export default {
  name: 'search-bar',
  components: {
    SearchJumpInfo
  },
  mixins: [link],
  props: {
    showSearch: null
  },
  data() {
    return {
      keyWord: '',
      showSimpleResult: false,
      searchData: null
    }
  },
  created() {
    this.$watch(
      'keyWord',
      debounce(newQuery => {
        this.$emit('keyWord', newQuery)
        this.searchInput()
      }, 200)
    )
  },
  watch: {
    showSearch() {
      let timer = setInterval(() => {
        if (document.getElementById('imitateInput')) {
          document.getElementById('imitateInput').focus()
          clearInterval(timer)
        }
      }, 300)
    }
  },
  computed: {
    searchType() {
      return this.$store.state.default.searchType
    }
  },
  // mounted() {
  //   document.addEventListener('click', this.closeSearch)
  // },
  // destroyed() {
  //   document.removeEventListener('click', this.closeSearch)
  // },
  methods: {
    listClickFn(item) {
      this.$refs.SearchJumpInfo.listClickFn(item, 'windowOpen', this.keyWord)
    },
    // input输入时弹出弹框 并加载数据
    async searchInput() {
      if (this.keyWord.trim().length === 0) {
        this.showSimpleResult = false
        return
      }
      this.showSimpleResult = true

      let data = {
        keyword: this.keyWord,
        size: 2
      }
      let res = await getSearchCount(data)
      if (res.status === 200) {
        let arr = JSON.parse(JSON.stringify(res.data.data))
        let empArr = []
        this.searchType.forEach(element => {
          let filterArr = arr.filter(item => item.type === element.value)
          if (filterArr.length > 0) {
            empArr.push(filterArr[0])
          }
        })
        res.data.data = empArr
        this.searchData = res.data
      }
    },
    closeSearch() {
      if (this.showSearch) {
        this.keyWord = ''
        this.showSimpleResult = false
        this.$emit('closeSearch')
      }
    },
    filterType(val) {
      let thisType = this.searchType.filter(item => item.value === val)
      return thisType[0].name
    },
    windowOpen(item) {
      let type = item && item.type ? item.type : 'all'
      window.open(`/search/${type}?keyWord=${this.keyWord}`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.input-search-enter-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}

.input-search-leave-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}
.input-search-enter,
.input-search-leave-to {
  opacity: 0;
}

.nav-list {
  line-height: 85px;
  background-color: $c-nav-bgc;
}
// 搜索框
.input-search-line {
  top: 0;
  right: 0;
  padding-left: 300px;
  .imitate-input-icon {
    position: absolute;
    top: 2px;
    left: 12px;
  }
  .input-s-mask {
    top: 0;
    left: 0;
    right: 0;
  }
}
.mask-css {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $c-transparent;
}
.input-search {
  height: 38px;
  line-height: 38px;
  margin-top: 27px;
}
.imitate-input {
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background-color: $c-white;
  padding: 0 20px 0 40px;
  box-shadow: 0 0 8px $c-input-placeholder;
  border-radius: 20px;
  font-size: 14px;
  color: $c-font-main-light;

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: $c-font-main-light !important;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: $c-font-main-light !important;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: $c-font-main-light !important;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: $c-font-main-light !important;
  }
}
// 搜索出现简单弹框
.input-search-simple {
  z-index: 1;
  background-color: $c-ceramic-search-bg;
  box-shadow: 0 0 8px $c-ceramic-li-bg;
  width: 100%;
  top: 85px;
  left: 0;
  padding: 14px;
  > ul {
    > li {
      line-height: 2;
      font-size: 14px;
      color: $c-white;
      padding: 0 10px;
      border-bottom: 1px solid $c-ceramic-border;
      &:last-child {
        border-bottom: 0 none;
      }
    }
  }
  .ss-li-title {
    line-height: 54px;
  }

  .ss-li-right-btn {
    &:hover {
      color: $c-hover !important;
    }
  }
  .ss-li-content {
    padding: 10px;
    .content-left {
      color: $c-m-gray;
      > div {
        padding: 0 5px;
      }
    }
    .content-left-bgc {
      // background-color: $c-eee6dc;
      border: 1px solid $c-ceramic-border;
      border-radius: 14px;
      padding: 0 10px;
    }
    .content-right {
      padding-left: 110px;
      height: 56px;
      .float-left,
      .float-right {
        overflow: hidden;
        -o-text-overflow: ellipsis; /* Opera 9-10 */
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .float-left {
        width: 90%;
        &:hover {
          color: $c-hover;
          a {
            color: $c-hover;
          }
        }
      }
    }
  }
}
.f-18 {
  font-size: 18px;
}
.c-hover {
  color: $c-hover !important;
}
.min-w-56 {
  min-width: 56px;
}
.z-1 {
  z-index: 1;
}
</style>
